(function () {
  const mount = document.getElementById('search-article-results');
  if (!mount) return;

  const query = mount.dataset.searchQuery?.trim();
  if (!query) return;

  const base = window.routes?.search_url || '/search';
  const searchParams = new URLSearchParams({
    q: query,
    type: 'article',
    section_id: 'search-article-results',
    'options[prefix]': 'last',
  });
  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (previewId) {
    searchParams.set('preview_theme_id', previewId);
  }
  const url = `${base}?${searchParams.toString()}`;

  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    })
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section =
        doc.querySelector('#shopify-section-search-article-results') ||
        doc.querySelector('[id*="search-article-results"]');
      if (!section) return;

      const inner = section.querySelector('[data-search-article-results]');
      if (!inner || !inner.querySelector('.blog-articles__article')) return;

      mount.innerHTML = section.innerHTML;
    })
    .catch(() => {});
})();
